import React from 'react';
import { ArrowRightIcon } from '@heroicons/react/24/outline';
import HeroPullQuote from '../../shared/HeroPullQuote';
import MessagingPillars from '../../shared/MessagingPillars';
import SemanticHRProductHeader from '../../shared/SemanticHRProductHeader';
import {
  MESSAGING_EYEBROW,
  MESSAGING_QUOTES,
  SEMANTIC_HR_CONTACT_HREF,
  SEMANTIC_HR_HERO,
} from '../../../../content/enterpriseMessaging';
import SemanticHRTourVisual from './SemanticHRTourVisual';

const techBadges = [
  'Snowflake Cortex Intelligence',
  'React Analytics App',
  'BI Report Gallery',
  'Power BI · Tableau Embed',
  'Workday & SuccessFactors',
];

const BADGE_CLASSES = [
  'badge-migration',
  'badge-brand',
  'badge-semantic',
  'badge-enterprise',
  'badge-accent',
];

export default function Hero() {
  return (
    <div className="container-x section-tight">
      <div className="relative mb-10 lg:mb-12 text-center">
        <p className="eyebrow">{MESSAGING_EYEBROW}</p>
        <div className="mt-3 flex justify-center">
          <SemanticHRProductHeader
            as="h1"
            titleClassName="min-w-0 max-w-full break-words text-4xl sm:text-5xl font-semibold tracking-tight text-ink-900 leading-[1.1]"
            taglineClassName="min-w-0 max-w-full break-words text-sm sm:text-base font-medium text-brand-700 leading-snug"
            logoClassName="mt-0.5 h-5 w-auto object-contain"
          />
        </div>
        <p className="mx-auto mt-4 max-w-3xl text-lg leading-relaxed text-ink-600">
          {SEMANTIC_HR_HERO.description}
        </p>
        <div className="mx-auto mt-6 max-w-3xl text-left">
          <HeroPullQuote eyebrow="Talk-to-data">
            {MESSAGING_QUOTES[3].text}
          </HeroPullQuote>
        </div>
        <MessagingPillars limit={2} className="mx-auto mt-6 max-w-3xl text-left" />
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <a href={SEMANTIC_HR_CONTACT_HREF} className="btn-primary btn-lg">
            Request demo
          </a>
          <a href="#metrics" className="btn-secondary btn-lg">
            HR metrics catalog
          </a>
          <a href="#architecture" className="link-text">
            Architecture
          </a>
        </div>
        <div className="mt-8 flex flex-wrap justify-center gap-2">
          {techBadges.map((badge, index) => (
            <span key={badge} className={BADGE_CLASSES[index % BADGE_CLASSES.length]}>
              {badge}
            </span>
          ))}
        </div>
      </div>

      <div className="relative w-full min-w-0 overflow-hidden rounded-2xl border border-ink-200 bg-white shadow-lg ring-1 ring-brand-100/50">
        <div className="border-b border-ink-100 bg-gradient-to-r from-[rgba(0,18,63,0.06)] to-brand-50 px-3 py-2">
          <p className="text-xs font-semibold text-ink-700">
            Split-screen copilot, chat, embedded BI gallery, and on-demand visualizations on Snowflake
          </p>
        </div>
        <SemanticHRTourVisual className="rounded-none border-0 shadow-none w-full" />
        <div className="flex flex-wrap items-center justify-between gap-2 border-t border-ink-100 px-3 py-2">
          <span className="text-[10px] font-medium text-ink-500" aria-hidden="true">
            React analytics app · Streamlit reference · governed Power BI embeds
          </span>
          <a
            href={SEMANTIC_HR_CONTACT_HREF}
            className="inline-flex min-h-[24px] items-center gap-1 text-xs font-semibold text-brand-600 hover:text-brand-700"
          >
            Request demo
            <ArrowRightIcon className="h-3 w-3" aria-hidden="true" />
          </a>
        </div>
      </div>
    </div>
  );
}
